<template>
  <div>
    <loading v-show="$store.state.isLoading" />
    <maintenance v-if="inMaintenance" />
    <router-view v-else />
  </div>
</template>

<script>
import Loading from '@/components/Loading';
import { PAISES_MANTENIMIENTO } from '@/utils/constants';
import Maintenance from '@/views/common/Components/Maintenance';

export default {
  name: 'App',
  components: { Maintenance, Loading },
  computed: {
    inMaintenance() {
      if (PAISES_MANTENIMIENTO.find((elem) => elem === 'ALL')) {
        return true;
      }

      return PAISES_MANTENIMIENTO.includes(this.$store.state?.country?.pais);
    }
  }
};
</script>

<style lang="scss"></style>
